<template>
  <v-menu
    v-if="hasApplications"
    v-model="isOpen"
    location="bottom end"
    @update:model-value="onMenuVisibilityChange"
  >
    <template #activator="{ props: activatorProps }">
      <SIconButton
        v-bind="activatorProps"
        role="button"
        icon="mdi-apps"
        aria-label="Applications"
        title="Applications"
        data-testid="contextual-app-menu-trigger"
      />
    </template>
    <div
      role="menu"
      aria-label="Applications menu"
      class="contextual-app-menu rounded-lg bg-white p-4"
    >
      <div class="grid grid-cols-3 gap-x-4 gap-y-6">
        <AppLink v-for="app in principalApps" :key="app.name" :app-data="app" />
      </div>
      <div v-if="hasBothGroups" role="separator" class="my-6 border-t border-gray-200" />
      <div class="grid grid-cols-3 gap-x-4 gap-y-6">
        <AppLink v-for="app in secondaryApps" :key="app.name" :app-data="app" />
      </div>
    </div>
  </v-menu>
</template>

<script setup lang="ts">
import AppLink from '@/components/AppLink/AppLink.vue'
import type { Application } from '@/types'
import { computed, ref } from 'vue'
import { SIconButton } from 'sima-suite-components-vue3'

const props = defineProps<{
  principalApps: Application[]
  secondaryApps: Application[]
}>()

const emit = defineEmits<{
  open: []
}>()

const isOpen = ref(false)
const hasApplications = computed(() => props.principalApps.length > 0 || props.secondaryApps.length > 0)
const hasBothGroups = computed(() => props.principalApps.length > 0 && props.secondaryApps.length > 0)

const onMenuVisibilityChange = (open: boolean) => {
  isOpen.value = open
  if (open) {
    emit('open')
  }
}
</script>

<style scoped>
.contextual-app-menu {
  box-shadow: var(--shadow-s);
  min-width: 18rem;
  max-width: min(26rem, calc(100vw - 2rem));
}
</style>